import { createFileRoute } from "@tanstack/react-router";
import { BlackFaqPage } from "@/components/black2x1/Black2x1Page";
import logoOficial from "@/assets/black2x1/black-logo-oficial.webp.asset.json";

const URL = "https://fisioemortopedia.com.br/black-faq";

const DESC =
  "Respostas para as principais perguntas dos grupos de WhatsApp da BLACK EM DOBRO da FEO: duas pós-graduações pelo preço de uma, formas de pagamento, acesso, TCC e ementas.";

export const Route = createFileRoute("/black-faq")({
  head: () => ({
    meta: [
      { title: "BLACK EM DOBRO · Perguntas frequentes | FEO" },
      { name: "description", content: DESC },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: "BLACK EM DOBRO · Perguntas frequentes" },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "BLACK EM DOBRO · Perguntas frequentes" },
      { name: "twitter:description", content: DESC },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preload", as: "image", href: logoOficial.url, fetchPriority: "high" as const },
    ],
  }),
  component: BlackFaqPage,
});
